import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  dialogPaper: {
    overflow: 'visible',
    // marginTop: '80px',
    // marginBottom: 'auto',
    margin: 'auto',
  },
  dialogContent: {
    overflow: 'visible',
  },
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  closeButton: {
    marginLeft: '8px',
    '& .MuiSvgIcon-root': {
      marginRight: '0px',
    },
  },
  radioGroup: {
    display: 'flex',
    width: '100%',
    marginBottom: '24px',
    flexDirection: 'row'
  },
  radioButton: {
    flex: 1,
    marginRight: '0px',
    alignItems: 'flex-start',
    '& input[type="radio"]': {
      display: 'none',
    },
  },
  textField: {
    width: '100%',
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
      margin: 0,
    },
  },
  labelRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '4px',
  },
  formLabel: {
    fontSize: '16px',
    fontWeight: foundations.typography.fontWeight.medium
  },
  characterCounter: {},
  listItem: {
    marginTop: '16px',
    width: '100%',
  },
  errorMsg: {
    marginTop: '8px'
  },
  dialogActions: {
    justifyContent: 'flex-end',
    gap: '8px',
    padding: '16px 24px'
  }
});
